export const SiteType = {
  NotSet: 0,
  GlobalSites: 1,
  MySites: 2,
  SharedSites: 3,
  RecycleBin: 4,
  MailBox: 5,
  AUSites: 6,
};

export const OfflineSyncStatus = {
  Unknown: "Unknown",
  Synced: "Synced",
  SyncedWithErrors: "SyncedWithErrors",
  Syncing: "Syncing",
  Conflict: "Conflict",
  Error: "Error",
};

export const SortDirectionOptions = {
  Ascending: "Ascending",
  Descending: "Descending",
};

export const ElementType = {
  Undefined: 0,
  Root: 1,
  Organization: 2,
  Department: 3,
  Shelf: 4,
  Folder: 5,
  Register: 6,
};

export const GridListConstant = {
  ExtensionIcon: "ExtensionIcon",
  IconItemStatus: "IconItemStatus",
  ItemUri: "ITEMURI",
};
